"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BufferHelper = /** @class */ (function () {
    function BufferHelper() {
    }
    BufferHelper.resize = function (data, newSize) {
        var newBuffer = new Uint8Array(newSize);
        newBuffer.set(data);
        return newBuffer;
    };
    return BufferHelper;
}());
exports.BufferHelper = BufferHelper;
